import React, { useContext } from "react";
import SubjectContext from "../../context/SubjectContext";
import CourseItemsCounter from "../../components/items/CourseItemsCounter";
import { headerSectionColor } from "../../services/defaultSettings";
import { motion } from "framer-motion";

const SubjectHeaderSection = () => {
    const { subject } = useContext(SubjectContext);

    return (
        <div className="relative negative-nav-margin">
            <motion.div
                initial={{ y: -200, scaleY: 0 }}
                animate={{ y: 0, scaleY: 1 }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
                className="absolute top-0 negative-nav-margin left-1/2 -translate-x-1/2 w-[140%] h-[50vh] bg-gradient-to-b from-yellow-400 to-yellow-200 rounded-b-full"
            ></motion.div>
            <motion.div
                initial={{ y: -200, scaleY: 0 }}
                animate={{ y: 0, scaleY: 1 }}
                transition={{ delay: 0.3, duration: 1.5, ease: "easeInOut" }}
                className="absolute top-0 negative-nav-margin right-1/2 -translate-x-1/2 w-[140%] h-[50vh] bg-gradient-to-b from-yellow-400 to-yellow-200 rounded-b-full"
            ></motion.div>
            <motion.div
                initial={{ y: -200, scaleY: 0 }}
                animate={{ y: 0, scaleY: 1 }}
                transition={{ delay: 0.6, duration: 1.5, ease: "easeInOut" }}
                className="absolute top-0 -z-10 negative-nav-margin inset-0 -translate-x-1/2 w-[140%] h-[50vh] bg-gradient-to-b from-yellow-400 to-yellow-200 rounded-b-full"
            ></motion.div>
            <header className="relative z-10 flex pt-[5rem] font-mont flex-col items-center text-center space-y-6 py-8">
                {/* Course Counter */}

                <h1 className="text-4xl font-extrabold text-gray-900">{subject.name}</h1>
                <CourseItemsCounter
                    text="الكورسات"
                    number={subject.courses_count}
                    icon="carbon:course"
                    className={`px-5 py-2 rounded-full flex items-center gap-2 text-lg font-semibold shadow-md ${
                        headerSectionColor === "rose"
                            ? "bg-yellow-300 text-gray-900"
                            : "bg-rose-500 text-white"
                    }`}
                    iconClassName="text-yellow-500 text-2xl"
                />

                <p className="text-lg text-gray-600">استكشف أحدث الكورسات والمواد التعليمية</p>
            </header>
        </div>
    );
};

export default SubjectHeaderSection;
